import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import _ from "underscore";
import { useIntersection } from "../../Hooks/customHooks";
import { START_GET_FIELD_STAFF_LIST } from "../../Actions/ActivityAction";
import {
  CircularProgress,
  Grid,
  TextField,
  Checkbox,
  Chip,
  Box,
} from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import "../../Sass/Common.scss";
import { getEllipsisName } from "../../utils/generalUtils";
import HtmlTooltipMain from "../../Components/Common/HtmlTooltipMain";

function StaffAutoComplete(props) {
  const {
    value,
    multiple,
    disabled,
    handleChange,
    staffFieldList,
    getStaffListAction,
    apiParams,
    disableEnter = true,
    maxValue,
    surgeryListFlag,
    helperText,
    error = false,
    maxVisibleChip = 1,
    textFieldProps = {
      required: true,
    },
    ...other
  } = props;
  const [selectSurgery, setSelectSurgery] = useState(
    multiple ? Object.values(value || {}) : value || {}
  );
  const [surgerySearchString, setSurgerySearchString] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [setTargetSurgery, entrySurgery] = useIntersection({ threshold: 0.1 });
  /** getvalue from list */
  useEffect(() => {
    if (multiple) {
      setSelectSurgery(Object.values(value || {}));
    } else {
      setSelectSurgery(value);
    }
  }, [value]);

  /** handle data on entry */
  useEffect(() => {
    if (entrySurgery.isIntersecting && staffFieldList.loading === false) {
      let params = {
        offset: staffFieldList?.data?.list?.length || 0,
        ...(surgerySearchString && { q: surgerySearchString }),
      };
      if (isOpen) {
        getStaffListAction(params);
      }
    }
  }, [entrySurgery]);

  /** search surgery  */
  const searchSurgeryDebounce = useRef(
    _.debounce((searchString, open) => {
      let params = {
        offset: 0,
      };
      if (searchString) {
        params.q = searchString;
      }
      if (open) {
        getStaffListAction(params);
      }
    }, 500)
  );

  /** handle surgery search */
  const handleSurgerySearch = (newValue) => {
    setSurgerySearchString(newValue);
    searchSurgeryDebounce.current(newValue, isOpen);
  };

  /** fecth surgery  */
  let fetchSurgery = () => {
    setIsOpen(true);
    let params = {
      offset: 0,
      ...(surgerySearchString && { q: surgerySearchString }),
    };
    getStaffListAction(params);
  };

  /** handle change surgery list */
  const handleChangeSurgeryList = (event, newValue) => {
    let newList = {};
    if (multiple) {
      newValue.map((surgery) => {
        newList[surgery.id] = surgery;
      });
    } else {
      newList = newValue;
    }
    setSelectSurgery(newValue);
    handleChange && handleChange(newList);
  };

  return (
    <>
      <Autocomplete
        multiple={multiple}
        classes={{
          option: "option",
          noOptions: "noOptions",
        }}
        disableCloseOnSelect={multiple}
        disabled={Boolean(disabled)}
        onOpen={fetchSurgery}
        onClose={() => {
          setIsOpen(false);
        }}
        noOptionsText={fetchSurgery}
        value={selectSurgery}
        onChange={handleChangeSurgeryList}
        options={staffFieldList?.data?.list || []}
        getOptionLabel={(option) => {
          return option.name || "";
        }}
        isOptionEqualToValue={(option, value) => {
          return option?.id === value?.id;
        }}
        onInputChange={(event, newValue) => {
          handleSurgerySearch(newValue);
        }}
        filterOptions={(option) => {
          let result = [...option];
          if (
            staffFieldList?.data?.list?.length < staffFieldList?.data?.total
          ) {
            result.push("FinalOption");
          }

          if (staffFieldList?.data?.list?.length === 0) {
            result.push({
              name: `No option found`,
            });
          }
          return result || [];
        }}
        getOptionDisabled={(option) => {
          if (option.name === "No option found") {
            return true;
          }
        }}
        renderOption={(props, option, { selected }) => {
          return (
            <React.Fragment>
              {typeof option === "object" ? (
                <Grid {...props} key={option?.id}>
                  {multiple && option?.id && <Checkbox checked={selected} />}
                  {option.name}
                </Grid>
              ) : (
                <Grid
                  className="autoCompleteInputLoader"
                  ref={setTargetSurgery}
                >
                  <CircularProgress size={20} />
                </Grid>
              )}
            </React.Fragment>
          );
        }}
        renderTags={(tagValue, getTagProps) => {
          if (tagValue.length === maxVisibleChip) {
            return tagValue.map((option, index) => {
              return (
                <HtmlTooltipMain title={option?.name}>
                  <Chip
                    key={index}
                    label={`${option.name}`}
                    {...getTagProps({ index })}
                    size="small"
                  />
                </HtmlTooltipMain>
              );
            });
          } else {
            return (
              <Box display="flex" alignItems="center">
                {tagValue
                  .slice(
                    0,
                    surgeryListFlag === true ? maxValue : maxVisibleChip
                  )
                  .map((option, index) => (
                    <HtmlTooltipMain title={tagValue[index].name}>
                      <Chip
                        label={`${getEllipsisName(tagValue[index].name, 8)}`}
                        {...getTagProps({ index: index })}
                        size="small"
                      />
                    </HtmlTooltipMain>
                  ))}
                {tagValue.length > maxVisibleChip && (
                  <HtmlTooltipMain
                    interactive={true}
                    title={
                      <Grid>
                        {tagValue.slice(maxVisibleChip).map((option, index) => (
                          <Box>{option.name}</Box>
                        ))}
                      </Grid>
                    }
                  >
                    <Box>
                      +{" "}
                      {tagValue.length -
                        Math.min(maxVisibleChip, tagValue.length)}{" "}
                      more
                    </Box>
                  </HtmlTooltipMain>
                )}
              </Box>
            );
          }
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            error={error}
            helperText={helperText}
            InputLabelProps={{ required: false }}
            inputProps={{
              ...params.inputProps,
              autoComplete: "new-password",
              endAdornment: (
                <React.Fragment>
                  {staffFieldList?.loading ? (
                    <CircularProgress color="inherit" size={20} />
                  ) : null}
                  {params.InputProps.endAdornment}
                </React.Fragment>
              ),
            }}
          />
        )}
        {...other}
      />
    </>
  );
}

const mapStateToProps = (state) => ({
  staffFieldList: state.activity.staffFieldList,
});

const mapDispatchToProps = (dispatch) => ({
  getStaffListAction: (payload) =>
    dispatch({ type: START_GET_FIELD_STAFF_LIST, payload }),
});

export default connect(mapStateToProps, mapDispatchToProps)(StaffAutoComplete);
